import sdkInstanceManager from '../managers/sdk-instance-manager';

type Properties = Record<string, any>;

export const track = (eventName: string, eventProperties?: Properties, userEmail?: string) => {
  if (!sdkInstanceManager.getIsInitialised()) {
    console.error('SDK must be initialised first');
    return;
  }
  if (!eventName || typeof eventName !== 'string') {
    console.error('Event name must be provided');
    return;
  }
  sdkInstanceManager.getApiClient()?.track(eventName, eventProperties, userEmail);
};
